// extracted by mini-css-extract-plugin
module.exports = {"intro":"user-attribute-view_intro__2LjCA","title":"user-attribute-view_title__BsXzL"};